type ShouldShowCreditPlanButtonLabelArgs = {
  hasCartButton: boolean;
  isAtOrAboveStandaloneLabelBreakpoint: boolean;
  isXlAndAbove: boolean;
};

export const shouldShowCreditPlanButtonLabel = ({
  hasCartButton,
  isAtOrAboveStandaloneLabelBreakpoint,
  isXlAndAbove
}: ShouldShowCreditPlanButtonLabelArgs) =>
  hasCartButton ? isXlAndAbove : isAtOrAboveStandaloneLabelBreakpoint;
